import SanskritCharacterService from "@/services/sanskritCharacter.service.js";

export default class SanskritCharacterUsecase {
  constructor () {
    this.SanskritCharacterService = new SanskritCharacterService();
  }

  async getSanskritCharacters () {
    const res = await this.SanskritCharacterService.list();

    return res;
  }
}
